<template>
  <ElementLayout>
    <template #element>
      <MultiSelect
        :model-value="el$.model"
        @update:model-value="el$.update($event)"
        :items="processedItems"
        :placeholder="fieldPlaceholder"
        :searchable="fieldSearchable"
        :disabled="el$?.isDisabled"
        :has-search-icon="hasSearchIcon"
        :has-other-option="hasOtherOption"
        @select-other="handleSelectOther"
      />
    </template>

    <template v-for="(component, slot) in elementSlots" #[slot]>
      <slot :name="slot" :el$="el$">
        <component :is="component" :el$="el$" />
      </slot>
    </template>
  </ElementLayout>
</template>

<script>
import { defineElement } from '@vueform/vueform'
import MultiSelect from '@/components/Form/Select/Select.vue'

export default defineElement({
  name: 'MultiSelectElement',
  components: { MultiSelect },
  computed: {
    fieldConfig() {
      // Resolve field config from Vueform schema paths, including nested list indices (e.g. `list.0.type`).
      const pathParts = this.el$?.path?.split('.').filter(Boolean) || []
      const fieldName = pathParts[pathParts.length - 1]
      const formSchema = this.el$?.form$?.schema
      if (!formSchema || !fieldName) return {}

      let cursor = formSchema
      for (const part of pathParts.slice(0, -1)) {
        if (/^\d+$/.test(part)) {
          cursor = cursor?.element
          continue
        }

        cursor = cursor?.[part] ?? cursor?.schema?.[part] ?? cursor?.element?.schema?.[part]
        if (!cursor) return {}
      }

      return cursor?.schema?.[fieldName] ?? cursor?.element?.schema?.[fieldName] ?? {}
    },
    rawItems() {
      return this.fieldConfig.items || []
    },
    processedItems() {
      const items = this.rawItems || []
      if (!Array.isArray(items)) return []
      
      // Normalize the items format
      return items.map(item => {
        if (item && typeof item === 'object') {
          return {
            label: item.label || item.Text || item.name || '',
            value: item.value || item.Value || item.id || ''
          }
        }
        return item
      })
    },
    fieldPlaceholder() {
      return this.fieldConfig.placeholder || ''
    },
    fieldSearchable() {
      return this.fieldConfig.searchable !== false
    },
    hasSearchIcon() {
      return this.fieldConfig.hasSearchIcon === true
    },
    hasOtherOption() {
      return this.fieldConfig.hasOtherOption === true
    }
  },
  methods: {
    handleSelectOther() {
      this.$emit('select-other')
    }
  }
})
</script>
